import type { DocPageContent } from '../docs-content'

const page = {
  order: 20,
  slug: 'keyboard-shortcuts',
  title: '键盘快捷键',
  description: '默认快捷键、自定义绑定、冲突、预设和重置。',
  category: '参考',
  sections: [
    {
      title: '默认分组',
      items: [
        '"播放"分组涵盖播放控制、逐帧步进和时间线跳转。',
        '"编辑"分组涵盖分割、合并、删除、波纹删除、冻结帧、链接、取消链接和微移。',
        '"工具"分组涵盖选择、修剪、剃刀、变速拉伸、波纹、滑移和滑行。',
        '标记、关键帧、源监视器、剪贴板、历史记录和 UI 以及项目分组映射到相应的编辑器界面。',
      ],
    },
    {
      title: '自定义快捷键',
      items: [
        '从工具栏打开"键盘快捷键"。',
        '搜索命令或快捷键。',
        '选择一个命令并录制新的绑定键。',
        '解决冲突或有意覆盖现有绑定。',
      ],
    },
    {
      title: '预设',
      items: [
        '导出键位预设用于备份或迁移。',
        '在浏览器或机器之间迁移时导入预设。',
        '重置所有快捷键以恢复默认设置。',
      ],
    },
  ],
} satisfies DocPageContent

export default page